import { KeyValue } from '@angular/common';

export function keyvalueOriginalOrder(a: KeyValue<string, any>, b: KeyValue<string, any>): number {
    return 0;
}
